import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { LocatiiService } from '../locatii.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { Locatie } from '../locatii.interface';

@Component({
    selector: 'app-add-locatii',
    templateUrl: './add-locatii.component.html',
    styleUrls: ['./add-locatii.component.scss']
})
export class AddLocatiiComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', Validators.required),
        address: new FormControl('', Validators.required),
    });

    constructor(
        private dialogRef: MatDialogRef<AddLocatiiComponent>,
        private locatiiService: LocatiiService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.locatiiService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, address } = this.form.value as Locatie;

        const newLocatie: Locatie = {
            name,
            address
        };

        this.locatiiService
            .addLocatie(newLocatie)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
